import React, { Component, Fragment } from 'react';

import { Field } from 'redux-form';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import MenuItem from 'material-ui/MenuItem';

import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';

import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import * as validator from 'helpers/Validator';

const FILE_FIELD_NAME = 'files';

const style = {
  no_padding: {
    padding: 0,
  },
  subheader_side_padding: {
    padding: '0 16px',
  },
  no_padding_minus_25: {
    padding: 0,
    marginBottom: '25px',
    marginTop: '15px',
  },
};
export default class FinishJobFormStep1 extends Component {
  render() {
    return (
      <Fragment>
        <div className="row" style={style.subheader_side_padding}>
          <div className="col-xs-12" style={style.no_padding}>
            <Field
              name="status"
              component={OutlinedSelect}
              validate={[validator.required]}
              fullWidth
              variant="outlined"
              label="Status"
            >
              <MenuItem value={'Fixed'}> Fixed </MenuItem>
              <MenuItem value={'Parts Needed'}>Parts Needed</MenuItem>
              <MenuItem value={'Contractor Needed'}>Contractor Needed</MenuItem>
            </Field>
          </div>
          <div className="col-xs-12" style={style.no_padding_minus_25}>
            <Field
              name="internal_note"
              component={TextField}
              label="Internal Notes"
              hintStyle={{ fontSize: '13px' }}
              rows="2"
              multiline
              fullWidth
              validate={[validator.required]}
              variant="outlined"
              style={{
                marginTop: '2px',
                fontSize: '15px',
                marginBottom: '-8px',
              }}
            />
          </div>
        </div>

        <div className="row" style={{ padding: '0 16px' }}>
          <Field
            name={FILE_FIELD_NAME}
            component={RenderDropzoneMultiFileInput}
            label={'Click to upload photos of your completed work here.'}
          />
        </div>
      </Fragment>
    );
  }
}
